import { type QuoteAccessorial } from 'spot-quote/domain/QuoteAccessorial'

import { Layout, Text, Tag } from '@loadsmart/loadsmart-ui'

type QuoteAccessorialsProps = {
  accessorials?: Array<QuoteAccessorial>
}

export function QuoteAccessorials({ accessorials }: QuoteAccessorialsProps) {
  return (
    <Layout.Stack space="xs">
      <Text variant="heading-sm-bold">Accessorial charges</Text>
      <Layout.Group space="xs">
        {(accessorials && accessorials.length > 0) ? (
          accessorials.map(accessorial => (
            <Tag key={accessorial.code} size="small" variant="warning">
              {accessorial.name}
            </Tag>
          ))
        ) : (
          <Tag size="small" variant="default">
            No charges requested
          </Tag>
        )}
      </Layout.Group>
    </Layout.Stack>
  )
}
